var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMessageUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Messages, Conversation /  Chat Round Unread"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 3.6665C9.18784 3.6665 3.66602 9.18832 3.66602 15.9998C3.66602 17.9746 4.12938 19.8382 4.95241 21.4906C5.28274 22.1538 5.40994 22.9469 5.20152 23.7258L4.40738 26.6938C4.26153 27.239 4.76023 27.7377 5.30534 27.5918L8.27339 26.7977C9.05232 26.5892 9.84536 26.7164 10.5086 27.0468C12.161 27.8698 14.0246 28.3332 15.9993 28.3332C22.8109 28.3332 28.3327 22.8113 28.3327 15.9998C28.3327 15.1538 28.2476 14.3286 28.086 13.5321C27.9761 12.9909 28.3258 12.463 28.867 12.3532C29.4083 12.2433 29.9361 12.593 30.046 13.1342C30.2341 14.061 30.3327 15.0194 30.3327 15.9998C30.3327 23.9159 23.9154 30.3332 15.9993 30.3332C13.7083 30.3332 11.54 29.7949 9.61688 28.837C9.32989 28.6941 9.03686 28.6637 8.79034 28.7297L5.82228 29.5238C3.7905 30.0675 1.93171 28.2087 2.47534 26.1769L3.26949 23.2088C3.33545 22.9623 3.30513 22.6693 3.16218 22.3823C2.20429 20.4591 1.66602 18.2909 1.66602 15.9998C1.66602 8.08376 8.08327 1.6665 15.9993 1.6665C16.9798 1.6665 17.9382 1.76509 18.8649 1.95321C19.4062 2.06307 19.7559 2.5909 19.646 3.13215C19.5362 3.6734 19.0083 4.0231 18.4671 3.91323C17.6706 3.75155 16.8454 3.6665 15.9993 3.6665ZM20.3327 6.6665C20.3327 3.90508 22.5713 1.6665 25.3327 1.6665C28.0941 1.6665 30.3327 3.90508 30.3327 6.6665C30.3327 9.42793 28.0941 11.6665 25.3327 11.6665C22.5713 11.6665 20.3327 9.42793 20.3327 6.6665ZM25.3327 3.6665C23.6758 3.6665 22.3327 5.00965 22.3327 6.6665C22.3327 8.32336 23.6758 9.6665 25.3327 9.6665C26.9895 9.6665 28.3327 8.32336 28.3327 6.6665C28.3327 5.00965 26.9895 3.6665 25.3327 3.6665Z",
    fill: "#1E2D66",
    stroke: "#1E2D66",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessageUnread);
export default __webpack_public_path__ + "static/media/No_message_unread.6d5da05d2392d4900cb414efec289d2f.svg";
export { ForwardRef as ReactComponent };